import initialState from '../store/initialState'
import skillsTypes from '../constants/skillsTypes'
import preferencesTypes from '../constants/preferencesTypes'

export default function skillsReducer(state = initialState.skills, action) {
  switch (action.type) {

    case skillsTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case skillsTypes.reset_skill: {
      return {
        ...initialState.skills,
        items: state.items,
        skill: state.skill,
        errors: []
      }
    }

    // INDEX
    case skillsTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case skillsTypes.index.success:
    case preferencesTypes.update.success:
    case preferencesTypes.index.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.skills,
        // pagination: action.payload.pagination,
        errors: []
      }
    }

    case skillsTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    case skillsTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case skillsTypes.create.success: {

      return {
        ...state,
        fetching: false,
        fetched: true,
        must_redirect: true,
        items: action.payload.skills,
        errors: []
      }
    }

    case skillsTypes.create.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/skillsReducer.js